import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, isDirty, getFormValues } from 'redux-form';

import {
  LeftColumnWrapper,
  RightColumnWrapper,
} from 'components/wrappers/pages';
import LibraryDeleteModal from 'components/LibraryDeleteModal';
import * as actItemHub from 'actions/businessLibrary/item';

import ItemForm from './ItemForm';
import FooterForm from '../FooterForm/Footer';
import ItemVariantModal from './ItemForm/ItemVariantModal';
import SalesTypeModal from './ItemForm/SalesTypeModal';
import ModifierModal from './ItemForm/ModifierModal';
import ConfirmationModal from './ItemForm/ConfirmationModal';
import styles from './ItemDetail.css';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Please enter a value';
  } else if (values.name.length > 100) {
    errors.name = 'Name too long';
  }

  const itemVariantsErrors = [];
  if (values.item_variants) {
    values.item_variants.forEach((iv, index) => {
      const memberError = {};
      if (!iv.name && values.item_variants.length > 1) {
        memberError.name = 'Please fill in Variant Name';
      }
      if (iv.price > 99999999999) {
        memberError.price = 'Price must be less than 99.999.999.999';
      }
      if (values.is_sales_type_price && iv.sales_type_item_variants) {
        memberError.sales_type_item_variants = [];
        iv.sales_type_item_variants.forEach((sti, index) => {
          memberError.sales_type_item_variants[index] = {};
          if (sti.price > 99999999999) {
            memberError.sales_type_item_variants[index].price =
              'Price must be less than 99.999.999.999';
          }
        });
      }
      if (Object.keys(memberError).length > 0) {
        itemVariantsErrors[index] = memberError;
      }
    });
  }
  if (itemVariantsErrors.length) {
    errors.item_variants = itemVariantsErrors;
  }

  return errors;
};

class ItemDetail extends React.Component {
  render() {
    const {
      itemDetail,
      handleSubmit,
      showDeleteModal,
      showConfirmItemModal,
    } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className={styles.form}>
          <form onSubmit={handleSubmit} className="full-height form-item">
            <LeftColumnWrapper openRightColumn>
              <ItemForm firstChild />
            </LeftColumnWrapper>
            <RightColumnWrapper openRightColumn isWhiteBackground>
              <ItemForm firstChild={false} />
            </RightColumnWrapper>
            <FooterForm
              itemDetail={itemDetail}
              onCancel={this._onCancel}
              handleSubmit={handleSubmit(this._onSubmitSave)}
              handleDelete={this._handleDelete}
            />
          </form>
          {/* MODAL */}
          <ItemVariantModal onSubmit={this._onSaveVariant} />
          <SalesTypeModal onSubmit={this._onSaveSalesType} />
          <ModifierModal onSubmit={this._onSaveModifiers} />
          <ConfirmationModal
            showConfirmItemModal={showConfirmItemModal}
            onCancel={this._onCancelSaveItem}
            onConfirmSaveItem={handleSubmit(this._onSaveItem)}
          />
          {itemDetail && itemDetail.id && (
            <LibraryDeleteModal
              name={itemDetail.name}
              onHide={this._onHideDeleteModal}
              showDeleteModal={showDeleteModal}
              title="Item"
              onDelete={this._confirmDelete}
            />
          )}
        </div>
      </div>
    );
  }

  _onSaveItem = values => {
    const { dispatch, itemForm, file } = this.props;
    values.file = file;
    if (itemForm.id) {
      dispatch(actItemHub.submitFormUpdate(values));
    } else {
      dispatch(actItemHub.submitFormCreate(values));
    }
  };

  _onSubmitSave = () => {
    const { dispatch } = this.props;
    dispatch(actItemHub.showConfirmItemModal());
  };

  _onCancel = () => {
    const { dispatch } = this.props;
    dispatch(actItemHub.onClickCancel());
  };

  _handleDelete = () => {
    const { dispatch } = this.props;
    dispatch(actItemHub.showDeleteModal());
  };

  _onCancelSaveItem = () => {
    const { dispatch } = this.props;
    dispatch(actItemHub.hideConfirmItemModal());
  };

  _onHideDeleteModal = () => {
    const { dispatch } = this.props;
    dispatch(actItemHub.hideDeleteModal());
  };

  _confirmDelete = () => {
    const { dispatch, itemForm } = this.props;
    dispatch(actItemHub.onDeleteitem(itemForm));
  };

  _onSaveVariant = value => {
    const { dispatch, isDirtyForm, itemForm } = this.props;
    if (isDirtyForm) {
      dispatch(actItemHub.onConfirmItemVariantModal(value, itemForm));
    } else {
      dispatch(actItemHub.onCancelItemVariantModal());
    }
  };

  _onSaveSalesType = value => {
    const { dispatch } = this.props;
    dispatch(actItemHub.onConfirmSalesTypeModal(value));
  };

  _onSaveModifiers = values => {
    const { dispatch } = this.props;
    dispatch(actItemHub.onConfirmModifierModal(values));
  };
}

const mapForm = {
  form: 'itemHub',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

function mapStateToProps(state) {
  const { loadingSpinner } = state;
  const { categories } = state.businessLibrary.itemHub;
  const {
    itemDetail,
    newCategory,
    previousCategoryId,
    showDeleteModal,
    showConfirmItemModal,
  } = state.businessLibrary.itemHub;
  const { file } = state.uploadImage.uploadImage;

  return {
    isDirtyForm: isDirty('modal_item_variants')(state),
    itemForm: getFormValues('itemHub')(state),
    categories,
    file,
    newCategory,
    loadingSpinner,
    itemDetail,
    showDeleteModal,
    showConfirmItemModal,
    previousCategoryId,
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(ItemDetail));
